import type { ReactNode } from "react";

/**
 * Chrome-less layout for public / pre-auth pages (#/brands/signup, #/login).
 * No nav, no global search, no badges — just a centered card on a neutral
 * background.
 */
export default function MinimalLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl">{children}</div>
    </div>
  );
}
